// extracted by mini-css-extract-plugin
module.exports = {"odonto_microcentro__redText":"OdontoMicrocentro_odonto_microcentro__redText__X4WBn","odonto_microcentro__image":"OdontoMicrocentro_odonto_microcentro__image__3RMT2"};